import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { DDE_MENU_ICONS } from '@/router/icons'
import { LicensePropertyView } from '@/views/Licenses/LicensePropertyView'
import { LicensesView } from '@/views/Licenses/LicensesView'

export const licensesRoutes: RouteObject[] = [
  {
    path: 'licenses',
    label: 'Licenses',
    icon: DDE_MENU_ICONS.LICENSES,
    platforms: [PLATFORM.DDE],
    children: [
      {
        index: true,
        element: <LicensesView />,
        platforms: [PLATFORM.DDE]
      },
      {
        path: ':licenseProperty',
        element: <LicensePropertyView />,
        platforms: [PLATFORM.DDE]
      }
    ]
  }
]
